import React from 'react';

type Props = {
  fill?: string;
  stroke?: string;
  className?: string;
  width?: string;
  height?: string;
};

const Web: React.FC<Props> = ({ className, fill = 'none', stroke = '#0B1215', width = '16', height = '16' }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1356_5990)">
      <path
        d="M8.00016 14.6668C11.6821 14.6668 14.6668 11.6821 14.6668 8.00016C14.6668 4.31826 11.6821 1.3335 8.00016 1.3335C4.31826 1.3335 1.3335 4.31826 1.3335 8.00016C1.3335 11.6821 4.31826 14.6668 8.00016 14.6668Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1.3335 8H14.6668" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M8.00016 1.3335C9.66768 3.15906 10.6153 5.52819 10.6668 8.00016C10.6153 10.4721 9.66768 12.8413 8.00016 14.6668C6.33264 12.8413 5.38499 10.4721 5.3335 8.00016C5.38499 5.52819 6.33264 3.15906 8.00016 1.3335Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1356_5990">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Web;
